import { createPinia } from 'pinia'
import { createApp, onMounted } from 'vue'
import { DefaultApolloClient } from '@vue/apollo-composable'


import App from '../src/App.vue'
import router from './router'

import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'

import apolloClient from './apollo'
import { fetchCsrfToken } from './csrf'
import { useUserStore } from './stores/user'

onMounted(async () => {
  await fetchCsrfToken()
})

const app = createApp(App)

app.provide(DefaultApolloClient, apolloClient)
app.use(createPinia())
app.use(router)
app.use(vuetify)
app.mount('#app')

// Fetch current user as soon as the app loads
const userStore = useUserStore()
userStore.fetchCurrentUser()